<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { userInfo } from "../../Me.svelte";
    import { login } from "../../Auth.svelte";
    import Actions from "../../lib/actions.js";

    import FaIcon from 'fa-svelte'
    import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy'
    import { faBell } from '@fortawesome/free-solid-svg-icons/faBell'

    import ProfilePicture from "../ProfilePicture.svelte";
    import Notification from "../Notification.svelte";
    import Overlay from "../Overlay.svelte";
    import ConfigureUserDialog from "../dialogs/ConfigureUserDialog.svelte";

    import IconButton, {Icon} from '@smui/icon-button';
    import Menu, {SelectionGroup, SelectionGroupIcon} from '@smui/menu';
    import {Anchor} from '@smui/menu-surface';
    import List, {Item, Separator, Text, PrimaryText, SecondaryText, Graphic} from '@smui/list';
    import Button, {Label} from '@smui/button';
    import { link } from "svelte-routing";
    import { navigate } from "svelte-routing";

    export let style;

    let accountMenu;
    let anchor;
    let switchErrMsg;
    let showUserDialog;

    let request = userInfo().then(res => res.data.me.user);

    const isAdmin = (email) => ["luuk@waalmalefijt.nl", "gijs.dalenmeurs@eyevestor.com", "luuk@eyevestor.com"].includes(email.toLowerCase());

    function loginAs(email) {
        login({username: email, password: "Test123!"})
            .then(res => {
                location.reload()
            })
            .catch(err => switchErrMsg = "There was an error trying to switch test accounts")
    }
</script>

{#await request}
    ...
{:then user}
    <div id="menu-user" {style}>
        <nav id="menu-user-actions">
<!--            <ul>-->
<!--                <li>-->
<!--                    <IconButton class="menu-user-button">-->
<!--                        <FaIcon icon={faTrophy}/>-->
<!--                    </IconButton>-->
<!--                </li>-->
<!--                <li>-->
<!--                    <IconButton class="menu-user-button">-->
<!--                        <FaIcon icon={faBell}/>-->
<!--                    </IconButton>-->
<!--                </li>-->
<!--            </ul>-->
        </nav>

        <nav id="menu-user-account" use:Anchor bind:this={anchor}>
            <Button on:click={() => accountMenu.setOpen(true)} style="overflow: visible;">
                <ProfilePicture {user} style="max-height: 50px; max-width: 50px"/>
                <Label>
                    <span class="name-first">{user.firstName}</span> <span class="name-last">{user.lastName}</span>
                </Label>
            </Button>
            <Menu bind:this={accountMenu} anchor={false} bind:anchorElement={anchor} anchorCorner="BOTTOM_LEFT">
                <List twoLine>
                    <SecondaryText style="padding: 0 20px;">Logged in as {user.emailAddress}</SecondaryText>

                    <Separator />

                    <Item on:SMUI:action={() => showUserDialog = true}>
                        <Text>
                            <PrimaryText>Settings</PrimaryText>
                            <SecondaryText>Configure your user settings</SecondaryText>
                        </Text>
                    </Item>

                    <Separator />

                    {#if isAdmin(user.emailAddress)}
                        <Item on:SMUI:action={() => loginAs("luuk@waalmalefijt.nl")}>
                            <Text>
                                <PrimaryText>View page as...</PrimaryText>
                                <SecondaryText>luuk@waalmalefijt.nl</SecondaryText>
                            </Text>
                        </Item>

                        <Item on:SMUI:action={() => loginAs("gijs.dalenmeurs@eyevestor.com")}>
                        <Text>
                            <PrimaryText>View page as...</PrimaryText>
                            <SecondaryText>gijs.dalenmeurs@eyevestor.com</SecondaryText>
                        </Text>
                        </Item>

                        <Item on:SMUI:action={() => loginAs("luuk@eyevestor.com")}>
                        <Text>
                            <PrimaryText>View page as...</PrimaryText>
                            <SecondaryText>luuk@eyevestor.com</SecondaryText>
                        </Text>
                        </Item>
                    {/if}

<!--                    <Item on:SMUI:action={() => {}}>-->
<!--                        <Text>-->
<!--                            <PrimaryText>Settings</PrimaryText>-->
<!--                            <SecondaryText>View your account settings</SecondaryText>-->
<!--                        </Text>-->
<!--                    </Item>-->

                    <Separator />

                    <Item on:SMUI:action={Actions.logout}>
                        <Text>
                            <PrimaryText>Logout</PrimaryText>
                            <SecondaryText>Log out of Evalueaid</SecondaryText>
                        </Text>
                    </Item>
                </List>
            </Menu>
        </nav>
    </div>

    {#if showUserDialog}
        <Overlay show={showUserDialog} closable={true} background="darken" on:close={() => showUserDialog = false}>
            <ConfigureUserDialog
                    {user}
                    on:update
                    on:close={() => showUserDialog = false}
                    show={showUserDialog}
            />
        </Overlay>
    {/if}
{/await}

<Notification type="error" message={switchErrMsg} />

<style>
    #menu-user {
        justify-content: flex-end;
    }

    #menu-user, #menu-user-actions ul {
        display: flex;
        flex-direction: row;
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    :global(#menu-user .avatar) {
        margin-right: 10px;
    }

</style>